import { Typography } from "@mui/material";
import { ReactNode, useContext } from "react";
import { Navigate } from "react-router-dom";
import { PATHS } from ".";
import AppContext from "../AppContext";
import { Roles } from "../types";

interface ConditionalRouteProps {
  children: ReactNode;
}

export function AdminRoute({ children }: ConditionalRouteProps) {
  const { account } = useContext(AppContext);

  const isAdmin = account?.role === Roles.Admin;

  if (account?.fullName === "loading...") {
    return <Typography variant="h5" sx={{ margin: "40px" }}>Checking access ...</Typography>;
  }

  if (!isAdmin) {
    return <Navigate to={PATHS.DASHBOARD} />;
  }

  return <>{children}</> || null;
}
